export const ADDRESS_MODAL_WIDTH_DESKTOP = '600px';
export const ADDRESS_MODAL_MAX_WIDTH_DESKTOP = '800px';
